// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"c1ea4913","213":"16f3869e","531":"38e9460b","586":"2651f728","787":"2ba23b58"}[chunkId] + ".chunk.js";
};